import React from "react";
import { Phone } from "lucide-react";
import content from "@/data/content.json";
import { AccentH2, Container, Label, Reveal, Section } from "./Primitives";
import { FlowLines } from "./FlowLines";

const { ansprechpartner: a, meta } = content;

export const Ansprechpartner = () => (
  <Section
    id="ansprechpartner"
    testId="section-ansprechpartner"
    className="has-lines overflow-hidden bg-[#1e2532] text-white on-dark"
  >
    <FlowLines />
    <Container>
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-[0.85fr_1.15fr] lg:gap-20">
        <Reveal>
          <div className="img-frame aspect-[4/5] w-full max-w-[240px] sm:max-w-[320px] lg:max-w-[430px]">
            <img src={a.image} alt={a.imageAlt} loading="eager" decoding="async" width="1128" height="1410" />
          </div>
        </Reveal>
        <Reveal>
          <Label>{a.label}</Label>
          <AccentH2 className="mt-7 max-w-[560px] text-3xl font-bold text-white md:text-[40px]">{a.h2}</AccentH2>
          <blockquote className="mt-9 max-w-[620px] border-l-2 border-[#3ecf9b] pl-7">
            <p className="font-display text-[21px] leading-[1.5] text-white md:text-[25px]">„{a.quote}“</p>
          </blockquote>
          <p className="mt-8 text-[17px] font-semibold text-white" data-testid="ansprechpartner-name">
            {a.name}
          </p>
          <p className="text-[15.5px] text-white/60">{a.role}</p>
          <a
            href={meta.phoneHref}
            data-testid="ansprechpartner-phone"
            className="mt-7 inline-flex items-center gap-3 font-display text-[24px] font-bold text-white md:text-[28px]"
          >
            <Phone size={22} className="text-[#3ecf9b]" />
            <span className="link-underline">{meta.phone}</span>
          </a>
        </Reveal>
      </div>
    </Container>
  </Section>
);
